import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { NgbCollapse, NgbDropdownModule, NgbModal, NgbProgressbarModule } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { Subject } from 'rxjs';
import { EmployeeRegistrationService } from '../../Model/EmployeeRegistration/employee-registration.service';
import { CommonService } from '../../Model/Common/common.service';
import { TooltipService } from '../../Util/Tooltip/tooltip.service';
import { SessionService } from '../../Util/Session/session.service';
import { ComboService } from '../../Model/Combo/combo.service';
import { DownloadSampleService } from '../../Model/DownloadSample/download-sample.service';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { RegisterExcelFilterComponent } from '../../Register/RegisterExcelFilter/register-excel-filter/register-excel-filter.component';

@Component({
  selector: 'app-emp-search',
  standalone: true,
  imports: [CommonModule, RouterModule, DataTablesModule, NgbProgressbarModule, FormsModule, NgbDropdownModule, LoaderComponent, NgbCollapse, NgSelectModule],
  templateUrl: './emp-search.component.html',
  styleUrl: './emp-search.component.scss'
})
export class EmpSearchComponent {
  isDisabled: boolean = false;
  EmployeeData = [] as any;
  FilterColumns = [] as any;
  // isCollapsed = true;
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  user = [] as any;
  Filter = {
    EmpMasterId: null,
    SelectType: 'History',
    EmployeeCode: null,
    EmpName: null,
    EmployeeOldCode: null,
    BranchName: null,
    Category: '',
    Ess_CustomSearchFilterId: null,
    FilterValue: null,
    IsDraft: null,
    UserId: null,


    // IsDraft: null,
    // //EmployeeCode: null,
    // EmployeeOldCode: null,
    // EmpName: null,
    // BranchName: null,
    // Category: '',
    // Ess_CustomSearchFilterId: null,
    // FilterValue: null,
  }

  dtoptions: DataTables.Settings = {};
  constructor(
    private route: ActivatedRoute,
    private employeeRegistration: EmployeeRegistrationService,
    protected common: CommonService,
    private tooltip: TooltipService,
    private combo: ComboService,
    private session: SessionService,
    private download: DownloadSampleService,
    private toast: ToastService,
    private modalService: NgbModal,
    private router: Router,
  ) {
    this.common.getPageRights();
    this.user = this.session.GetUserDetails();
    this.Filter.UserId = this.user.UserId
    this.Filter.Category = this.router.url.split('/')[2];
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.GetData();
    this.ComboLoad('CustomSearch');
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  setSelectType(type: number) {
    //this.Filter.ListType = type;
    this.GetData();
  }

  // GetData() {
  //   this.isDisabled = true;
  //   if (this.Filter.ListType == 1 || this.Filter.ListType == 2) {
  //     this.Filter.TabName = 'Search';

  //   } else if (this.Filter.ListType == 3) {
  //     this.Filter.TabName = 'PreOnBoarding';
  //     console.log(this.Filter.TabName);
  //   }

  //   if (this.Filter.ListType == 1) {
  //     this.Filter.IsDaft = false;
  //   } else {
  //     this.Filter.IsDaft = true;
  //   }
  //   this.employeeRegistration.EmpRegSelectGetData({ 'SelectType': this.Filter.TabName, 'EmpMasterId': 0, 'IsDraft': this.Filter.IsDaft }).subscribe({
  //     next: (response) => {
  //       this.EmployeeData = Object.values(response.Table)
  //       this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
  //         dtInstance.destroy();
  //         this.dtTrigger.next(null);
  //       });
  //       this.isDisabled = false;
  //     },
  //     complete: () => { },
  //     error: (error) => {
  //       this.isDisabled = false;
  //     },
  //   });
  // }

  GetData() {
    this.isDisabled = true;
    // if (this.Filter.ListType == 1) {
    //   this.Filter.IsDraft = false;
    // } else {
    //   this.Filter.IsDraft = true;
    // }
    this.employeeRegistration.ESS_EmpRegistration_SearchGet(this.Filter).subscribe({
      next: (response) => {
        if (response.Table) {
          this.EmployeeData = Object.values(response.Table)
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next(null);
          });
        } else {
          this.EmployeeData = Object.values([])
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next(null);
          });
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ComboLoad(Combotype: String) {
    this.isDisabled = true;
    this.combo.ComboLoad({
      'Combotype': Combotype, 'BranchId': 0, 'ClientId': 0, 'SiteId': 0, 'DesignationId': 0, 'EmpType': this.Filter.Category, 'StateId': 0,
      'DistrictId': 0,
      'EmpMasterID': 0
    }).subscribe({
      next: (response) => {
        if (Combotype == 'CustomSearch') {
          if (response.ComboLoad) {
            this.FilterColumns = response.ComboLoad;
          }
        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ESS_GetEmployeeDumpReport(result: any) {
    this.isDisabled = true;
    this.employeeRegistration.ESS_GetEmployeeDumpReport(result).subscribe({
      next: (response) => {
        if (response && response.Table && response.Table.length > 0) {
          this.download.exportToExcel(response.Table, "Employee");
        }
        else {
          this.toast.show({ message: 'Data not found!', type: toastTypeEnum.warning });
        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  // ESS_GetEmployeeDumpFilter() {
  //   const modalRef = this.modalService.open(RegisterExcelFilterComponent, { size: 'lg', backdrop: 'static', });
  //   modalRef.componentInstance.EmpType = this.Filter.Category;
  //   modalRef.result.then((result: any) => {
  //     if (result != null && result != undefined) {
  //       this.ESS_GetEmployeeDumpReport(result);
  //     }
  //   });
  // }


  exportToExcel() {
    this.isDisabled = true
    if (this.EmployeeData.length > 0) {
      this.download.exportToExcel(this.EmployeeData, "Employee_data");
      this.isDisabled = false
    }
  }

}
